import { useTranslation } from 'react-i18next';
import { Form } from '@/components';
import { ProjectDto } from '@/core';
import { useColumnsOptions, useTypeOptions } from './hooks';
import classes from './TableFormInputs.module.scss';

type PropsType = {
  projectData: ProjectDto;
  handleChangePickedColumns: (columns: string[]) => void;
  handleChangeType: (type: string) => void;
};

export const TableFormInputs = (props: PropsType) => {
  const { projectData, handleChangePickedColumns, handleChangeType } = props;
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const columnsOptions = useColumnsOptions(projectData);
  const typeOptions = useTypeOptions();

  return (
    <div className={classes.inputsWrapper}>
      <div className={classes.typeSelect}>
        <Form.Select
          label={false}
          options={typeOptions}
          name="type"
          allowClear={false}
          onChange={handleChangeType}
        />
      </div>
      <div className={classes.tableNameInput}>
        <Form.Input
          label={false}
          name="name"
          allowClear
          required
          placeholder={t('addTables.placeholder.name')}
        />
      </div>
      <div className={classes.columnsSelect}>
        <Form.Select
          mode="multiple"
          label={false}
          options={columnsOptions}
          name="columns"
          placeholder={t('addTables.placeholder.columns')}
          required
          allowClear={false}
          onChange={handleChangePickedColumns}
          maxTagCount="responsive"
        />
      </div>
    </div>
  );
};
